import React from 'react';
import { Brain, TrendingUp, Camera, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';



const benefits = [
  {
    icon: Brain,
    title: 'AI-Powered Descriptions',
    description: 'Generate compelling, SEO-optimized listing descriptions in seconds. Our AI analyzes your property details and crafts professional copy that attracts buyers.',
    action: '/create-listing?step=generate-copy',
    cta: 'Try AI Descriptions',
    color: '#00D4FF'
  },
  {
    icon: TrendingUp,
    title: 'Automated Market Analysis',
    description: 'Get instant pricing recommendations based on real-time market data, comparable sales, and neighborhood trends to price your listings competitively.',
    action: '/fair-price-analysis',
    cta: 'Analyse Market',
    color: '#7B2FFF'
  },
  {
    icon: Camera,
    title: 'Photo Enhancement Suggestions',
    description: 'Receive AI-driven recommendations for photo angles, lighting improvements, and staging tips that make your listings stand out in search results.',
    action: '/create-listing?step=photos',
    cta: 'Enhance Photos',
    color: '#00FF88'
  },
  {
    icon: Users,
    title: 'Integrated Lead Capture',
    description: 'Built-in lead forms, inspection booking, and buyer inquiry management keep all your leads organized and responsive in one place.',
    action: '/agent-dashboard',
    cta: 'View Lead Tools',
    color: '#FF6B35'
  }
];

const BenefitsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4" id="benefits">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8F4FD' }}>
            Everything You Need to List Smarter
          </h2>
          <p className="text-base" style={{ color: '#6B9EC4' }}>Built for agents who want results, not complexity.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits?.map((benefit, i) => {
            const Icon = benefit?.icon;
            return (
              <div
                key={i}
                className="p-6 rounded-2xl transition-all duration-300 flex flex-col cursor-pointer group"
                style={{ background: 'rgba(0, 212, 255, 0.04)', border: '1px solid rgba(0, 212, 255, 0.12)' }}
                onClick={() => navigate(benefit?.action)}
                onMouseEnter={e => {
                  e.currentTarget.style.border = `1px solid ${benefit?.color}55`;
                  e.currentTarget.style.background = `${benefit?.color}0D`;
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = `0 8px 30px ${benefit?.color}20`;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.border = '1px solid rgba(0,212,255,0.12)';
                  e.currentTarget.style.background = 'rgba(0,212,255,0.04)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
                  background: `${benefit?.color}25`,
                  border: `1px solid ${benefit?.color}40`
                }}>
                  <Icon size={22} color={benefit?.color} />
                </div>
                <h3 className="text-base font-semibold mb-2" style={{ color: '#E8F4FD' }}>{benefit?.title}</h3>
                <p className="text-sm leading-relaxed flex-1" style={{ color: '#6B9EC4' }}>{benefit?.description}</p>
                <div className="flex items-center gap-1 mt-4 text-xs font-semibold transition-all" style={{ color: benefit?.color }}>
                  {benefit?.cta}
                  <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
